import {
  ADD_SEARCH_TAG,
  REMOVE_SEARCH_TAG,
  CLEAR_SEARCH_TAG,
} from './constants'

const removeSearchTag = (state = [], action) => {
  const index = state.findIndex(
    i => i.toLowerCase() === action.tag.toLowerCase()
  )
  if (index !== -1) {
    state.splice(index, 1)
  }
  return [...state]
}

export default (state = [], action) => {
  switch (action.type) {
    case ADD_SEARCH_TAG:
      return [...state, action.tag]
    case REMOVE_SEARCH_TAG:
      return removeSearchTag(state, action)
    case CLEAR_SEARCH_TAG:
      return []
    default:
      return state
  }
}
